import React from 'react'
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined'
import DeleteButton from '../DeleteButton'
import { hasRole } from '../../../utils/checkRole'
import { UserRole } from '../../../types/keycloak'

type Props = {
  roles: string[]
  onEdit?: () => void
  onDelete?: () => void
  /** Context shown in the delete confirmation dialog */
  deleteItem?: import('../DeleteButton').DeleteItemMeta
  canEditRoles?: UserRole[]
  canDeleteRoles?: UserRole[]
}

const DEFAULT_EDIT = [UserRole.RSSI, UserRole.SSI_TEAM, UserRole.ADMIN]
const DEFAULT_DELETE = [UserRole.RSSI, UserRole.ADMIN]

export function DetailRowActions({
  roles,
  onEdit,
  onDelete,
  deleteItem,
  canEditRoles = DEFAULT_EDIT,
  canDeleteRoles = DEFAULT_DELETE,
}: Props) {
  const canEdit = canEditRoles.some((r) => hasRole(roles, r))
  const canDelete = canDeleteRoles.some((r) => hasRole(roles, r))

  if (!canEdit && !canDelete) return null

  return (
    <>
      {canEdit && onEdit ? (
        <button
          type="button"
          className="detail-icon-btn"
          title="Edit"
          onClick={onEdit}
        >
          <DriveFileRenameOutlineOutlinedIcon sx={{ fontSize: 16 }} />
        </button>
      ) : null}
      {canDelete && onDelete ? (
        <DeleteButton onDelete={onDelete} item={deleteItem} />
      ) : null}
    </>
  )
}

export function canManageMission(roles: string[]) {
  return (
    hasRole(roles, UserRole.RSSI) ||
    hasRole(roles, UserRole.SSI_TEAM) ||
    hasRole(roles, UserRole.ADMIN)
  )
}
